module.exports = __webpack_public_path__ + "img/trash-bin.97dbdc6d.svg";